<div class="relative flex min-w-0 flex-auto flex-col truncate">
  <!-- Main -->
  <div class="m-auto flex flex-auto flex-col px-6 py-4 sm:px-16 sm:pb-20">
    <!-- Activity feed -->
    <div class="flex w-full max-w-3xl justify-center">
      @if (activities(); as activities) {
        <div>
          <ol>
            <!-- Activities -->
            @for (
              activity of activities;
              track trackByFn(i, activity);
              let i = $index;
              let first = $first;
              let last = $last
            ) {
              <!-- Date separator -->
              @if (first || !isSameDay(activity.date, activities[i - 1].date)) {
                <li class="relative flex py-3">
                  <div
                    class="text-md relative rounded-full bg-primary px-6 py-2 leading-5 font-medium text-white"
                  >
                    {{ getRelativeFormat(activity.date) | titlecase }}
                  </div>
                </li>
              }

              <!-- Activity -->
              <li class="relative flex py-3">
                <!-- Line -->
                @if (!last && isSameDay(activity.date, activities[i + 1].date)) {
                  <div class="absolute top-7 left-5 -ml-px h-full w-0.5 bg-gray-5"></div>
                }

                <div class="relative flex flex-auto items-center gap-4">
                  <!-- Icon -->
                  @if (activity.icon && !activity.avatar) {
                    <div
                      class="mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-4"
                    >
                      <mat-icon class="icon-size-5 text-white" [svgIcon]="activity.icon"> </mat-icon>
                    </div>
                  }

                  <!-- Image -->
                  @if (activity.avatar) {
                    <aura-avatar
                      [srcImage]="activity.avatar.url"
                      [label]="activity.avatar.text"
                      [size]="'l'"
                    />
                  }

                  <!-- Content -->
                  <div class="flex flex-auto flex-col items-start">
                    <!-- Description -->
                    @if (activity.description) {
                      <div [innerHTML]="activity.description"></div>
                    }
                    <div
                      class="text-md mt-2 flex flex-col leading-5 sm:mt-1 sm:flex-row sm:items-center sm:space-x-2"
                    >
                      <!-- Date -->
                      <div class="text-sm text-gray">
                        {{ activity.date | luxonDate: 'dd/LL/yyyy HH:mm' }}
                      </div>
                      <!-- Linked content -->
                      @if (activity.linkedContent) {
                        <div class="hidden sm:block">&bull;</div>
                        <!-- Internal link -->
                        @if (activity.useRouter) {
                          <a class="cursor-pointer text-primary" [routerLink]="activity.link">
                            {{ activity.linkedContent }}
                          </a>
                        }
                        <!-- External link -->
                        @if (!activity.useRouter) {
                          <a class="cursor-pointer text-primary" [href]="activity.link" target="_blank">
                            {{ activity.linkedContent }}
                          </a>
                        }
                      }
                    </div>
                    <!-- Extra content -->
                    @if (activity.extraContent) {
                      <div
                        class="mt-4 rounded-lg bg-gray-2 px-5 py-4 dark:bg-gray-8"
                        [innerHTML]="activity.extraContent"
                      ></div>
                    }
                  </div>
                </div>
              </li>
            }
          </ol>
          <div #sentinel class="h-40 w-full"></div>
        </div>
      } @else {
        Loading...
      }
    </div>
  </div>
</div>
